import { useEffect } from "react";
import HomeTemplate from "../components/templates/HomeTemplate";
import { useNavigate } from "react-router-dom";

const Home = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate("/login");
    }, [navigate]);

    return <HomeTemplate/>;
};

export default Home;